<template>
  <el-form ref="form" :model="form" label-width="120px">
    <!-- 投放机型 -->
    <el-form-item label="投放机型">
      <el-input v-model="form.brand" disabled value="vivo"></el-input>
    </el-form-item>
    <el-form-item label="cookie">
      <el-input v-model="form.cookie" ></el-input>
    </el-form-item>

    <!-- 落地页类型 -->
    <el-form-item label="落地页类型">
      <el-select v-model="form.pageType">
        <el-option label="DP" value="DP"></el-option>
        <el-option label="H5" value="H5"></el-option>
      </el-select>
    </el-form-item>

    <!-- 归属渠道 -->
    <el-form-item label="归属渠道">
      <el-select
        v-model="form.clientId"
        @change="handleChannelChange"
        placeholder="请选择渠道"
      >
        <el-option
          v-for="channel in channelOptions"
          :key="channel.clientId"
          :label="channel.label"
          :value="channel.clientId"
        ></el-option>
      </el-select>
    </el-form-item>

    <!-- 广告主 -->
    <el-form-item label="广告主">
      <el-input
        type="textarea"
        :rows="4"
        v-model="form.advertiserText"
        placeholder="每行一个广告主ID"
      ></el-input>
    </el-form-item>
    <el-form-item label="备注">
      <el-input v-model="form.memo" ></el-input>
    </el-form-item>
    <!-- 投放子平台 -->
    <el-form-item label="投放子平台">
      <el-radio-group v-model="form.subPlatform">
        <el-radio label="站内"></el-radio>
        <el-radio label="联盟"></el-radio>
      </el-radio-group>
    </el-form-item>

    <!-- 事件源类型 -->
    <el-form-item label="事件源类型">
      <el-radio-group v-model="form.srcType">
        <el-radio label="Web">网址</el-radio>
        <el-radio label="Quickapp">快应用</el-radio>
      </el-radio-group>
    </el-form-item>

    <!-- 回传事件类型 -->
    <el-form-item label="回传事件类型">
      <el-select v-model="form.eventType">
        <el-option label="加桌" :value="10"></el-option>
        <el-option label="激活" :value="0"></el-option>
      </el-select>
    </el-form-item>

    <!-- 素材落地页 -->
    <el-form-item label="素材落地页">
      <el-select v-model="form.specialPage">
        <el-option label="  " :value="0"></el-option>
        <el-option label="短剧页面" :value="12"></el-option>
        <el-option label="工具-手机清理" :value="1408"></el-option>
        <el-option label="壁纸大全" :value="1409"></el-option>
        <el-option label="运动计步" :value="1410"></el-option>
        <el-option label="字体大小" :value="1411"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </el-form-item>
  </el-form>
</template>


<script>
import axios from "axios";
import XLSX from "xlsx";
export default {
  data() {
    return {
      form: {
        brand: 'vivo',
        pageType: 'DP',
        clientId: '',
        packageName: '',
        parentId: '',
        advertiserText: '',
        subPlatform: '站内',
        srcType: 'Web',
        eventType: 10,
        specialPage: 0,
        cookie:'',
        resultList:[]

      },
      channelOptions: [
        { label: '望舒天气', clientId: '14663', packageName: 'com.wangsh.tq', parentId: 14663 },
        { label: '电源宝', clientId: '14653', packageName: 'com.dianyuan.bao', parentId: 14653 },
        { label: '刷好剧', clientId: '10707', packageName: 'com.haoju.shua', parentId: 10707 },

        { label: '晴阅小说', clientId: '14258', packageName: 'com.qingyue.xsqy', parentId: 14258 },
        { label: '食玉炊桂', clientId: '14397', packageName: 'com.shiyu.cg', parentId: 14397 },

        { label: '畅悠谷', clientId: '14284', packageName: 'com.changyou.gu', parentId: 14284 },
        { label: '闪剧星球', clientId: '14391', packageName: 'com.shanju.xqqy', parentId: 14391 },
        { label: '百步健', clientId: '14288', packageName: 'com.baibu.jian', parentId: 14288 },
        { label: '成课堂', clientId: '14289', packageName: 'com.chengyu.tang', parentId: 14289 },


        { label: '元界测评', clientId: '14217', packageName: 'com.yuanjie.cpqy', parentId: 14217 },
        { label: '鲜味指南', clientId: '14120', packageName: 'com.xianwei.znqy', parentId: 14120 },
        { label: '随行充电', clientId: '14121', packageName: 'com.suixing.cdqy', parentId: 14121 },

        { label: '晴雨喵言', clientId: '12515', packageName: 'com.qingy.miaoy', parentId: 12515 },
        { label: '气象趣盒', clientId: '14010', packageName: 'com.qix.quh', parentId: 14010 },
        { label: '云图秘雨', clientId: '14009', packageName: 'com.yuntu.miy', parentId: 14009 },

        { label: '惠风和畅', clientId: '14016', packageName: 'com.huifeng.hc', parentId: 14016 },
        { label: '智诚语', clientId: '13782', packageName: 'com.chengyu.zhi', parentId: 13782 },
        { label: '漫游天下', clientId: '13781', packageName: 'com.manyou.tx', parentId: 13781 },

        { label: '遂风星象', clientId: '13876', packageName: 'com.zhufeng.xx', parentId: 13876 },

        { label: '倾心测评', clientId: '2526', packageName: 'com.qingxin.cp', parentId: 2526 },

        { label: '优剧看', clientId: '13628', packageName: 'com.movie.kan', parentId: 13628 },

        { label: '灵泽天气', clientId: '13646', packageName: 'com.lingze.tq', parentId: 13646 },

        { label: '乐风气象', clientId: '13569', packageName: 'com.qx.lefeng', parentId: 13569 },
        { label: '北星准测', clientId: '13268', packageName: 'com.beixing.ce', parentId: 13268 },

        { label: '速燃计步', clientId: '13196', packageName: 'com.suran.jbhy', parentId: 13196 },

        { label: '柚甜短剧', clientId: '10706', packageName: 'com.ju.youtian', parentId: 10706 },

        { label: '气象眼', clientId: '12922', packageName: 'com.qixiang.yan', parentId: 12922 },
        { label: '四时气象', clientId: '12904', packageName: 'com.qx.sishi', parentId: 12904 },
        { label: '天讯宝', clientId: '12695', packageName: 'com.tianxun.bao', parentId: 12695 },

        { label: '银竹气象', clientId: '12488', packageName: 'com.yinzhu.qx', parentId: 12488 },

        { label: '书舟行', clientId: '12074', packageName: 'com.sz.xingyc', parentId: 12074 },
        { label: '追书鸭', clientId: '12075', packageName: 'com.yczhuis.ya', parentId: 12075 },


        { label: '趣语集', clientId: '12256', packageName: 'com.quyu.ji', parentId: 12256 },

        { label: '岚烟壁纸', clientId: '11964', packageName: 'com.lanyan.picture', parentId: 11964 },
        { label: '棱镜扫描', clientId: '11966', packageName: 'com.lengjing.saomiao', parentId: 11966 },

        { label: '流萤账本', clientId: '11809', packageName: 'com.firefly.zhangben', parentId: 11809 },
        { label: '悦趣', clientId: '11687', packageName: 'com.yue.qu', parentId: 11687 },
        { label: '甜豆记', clientId: '11561', packageName: 'com.sweet.douji', parentId: 11561 },
        { label: '柠初壁纸', clientId: '11592', packageName: 'com.ningchu.pic', parentId: 11592 },

        { label: '趣读岛', clientId: '11220', packageName: 'com.qudu.dao', parentId: 11220 },
        { label: '萌阅轩', clientId: '11221', packageName: 'com.mengyue.xuan', parentId: 11221 },
        { label: '星语笺', clientId: '11132', packageName: 'com.xingyu.jiansd', parentId: 11132 },
        { label: '翎羽阅', clientId: '11083', packageName: 'com.lingyu.yue', parentId: 11083 },
        { label: '掌上充', clientId: '10754', packageName: 'com.chong.zs', parentId: 10754 },
        { label: '趣有剧', clientId: '10817', packageName: 'com.qu.youju', parentId: 10817 },
        { label: '岚风书斋', clientId: '10745', packageName: 'com.lanfeng.bookstore', parentId: 10745 },
        { label: '达趣漫画', clientId: '10744', packageName: 'com.daqu.manhua', parentId: 10744 },
        { label: '籁天气', clientId: '10684', packageName: 'com.tianqi.lai', parentId: 10684 },
        { label: '悠悠享看', clientId: '20240429028', packageName: 'com.look.youyou', parentId: 1618 },
        { label: '欢欣看', clientId: '9798', packageName: 'com.huanxin.kan', parentId: 9798 },
        { label: '青读', clientId: '9678', packageName: 'com.qing.read', parentId: 9678 },
        { label: '鑫剧集', clientId: '9676', packageName: 'com.xin.haoju', parentId: 9676 },
        { label: '新幽剧', clientId: '9675', packageName: 'com.youju.xin', parentId: 9675 },
        { label: '优读阁', clientId: '9677', packageName: 'com.youdu.ge', parentId: 9677 },
        { label: '森町壁纸', clientId: '9383', packageName: 'com.senting.picture', parentId: 9383 },

        { label: '柒野壁纸', clientId: '9382', packageName: 'com.sevenye.picture', parentId: 9382 },
        { label: '哇塞汇', clientId: '20240614021', packageName: 'com.ws.hui', parentId: 2006 },
        { label: '赏阅集', clientId: '9197', packageName: 'com.seeyue.ji', parentId: 9197 },
        { label: '探云记', clientId: '7833', packageName: 'com.tanyun.ji', parentId: 7833 },
        { label: '九里云', clientId: '4309', packageName: 'com.jiu.yunli', parentId: 4309 },
        { label: '新饕餮集', clientId: '4204', packageName: 'com.taotie.chi', parentId: 4204 },
        { label: '夜烛', clientId: '20240827039', packageName: 'com.ye.du', parentId: 2386 },
        { label: '欧脉多多', clientId: '8498', packageName: 'com.omy.dd', parentId: 8498 },
        { label: '草堂吟', clientId: '8522', packageName: 'com.caotang.yin', parentId: 8522 },
        { label: '短剧汇', clientId: '8524', packageName: 'com.duanju.hui', parentId: 8524 },
        { label: '火苗小说', clientId: '20240604084', packageName: 'com.huomiao.novel', parentId: 1831 },
        { label: '且看新篇', clientId: '1871', packageName: 'com.qiekan.xinpian', parentId: 1871 },
        { label: '蓝莓', clientId: '20240429006', packageName: 'com.lanmei.book', parentId: 1614 },
        { label: '胡桃', clientId: '20240604102', packageName: 'com.hutao.xiaos', parentId: 1886 },
        { label: '瓦力', clientId: '20240429030', packageName: 'com.wali.menu', parentId: 1619 },
        { label: '摇光', clientId: '2947', packageName: 'com.yao.guang', parentId: 2947 },
        { label: '今日有剧', clientId: '6034', packageName: 'com.look.youju', parentId: 6034 },
        { label: '新-蓝莓', clientId: '4201', packageName: 'com.lanmei.book', parentId: 4201 },
        { label: '念有云', clientId: '20240604091', packageName: 'com.nianyouyun.novel', parentId: 1837 },

        { label: '浙江VIVO-新-念有云', clientId: '7205', packageName: 'com.nianyouyun.novel', parentId: 7205 },
        { label: '浙江VIVO-行手记', clientId: '7834', packageName: 'com.xingshou.ji', parentId: 7834 },
        // { label: '念有云', clientId: '20240604091', packageName: 'com.nianyouyun.novel', parentId: 1837 }
      ]
    }
  },
  created() {

  },
  methods: {
    // 精简版（推荐）
    handleChannelChange(clientId) {
      const selected = this.channelOptions.find(item => item.clientId === clientId)
      this.form.packageName = selected.packageName
      this.form.parentId = selected.parentId
    },
    async submitForm() {
      const advertiserIds = this.form.advertiserText
        .split('\n')
        .filter(item => item.trim());

      // 存储所有请求结果
      const  self = this
      const results = [];
      self.resultList = []
      try {
        for (const [index, uuid] of advertiserIds.entries()) {
          console.log(`正在发送第 ${index + 1}/${advertiserIds.length} 个请求`);

          const  data = {
            cookie: this.form.cookie,
            memo: this.form.memo || "",
            pageType: this.form.pageType,
            brand: this.form.brand,
            subPlatform: this.form.subPlatform,
            clientId: this.form.clientId,
            eventType: this.form.eventType,
            uuid: uuid.trim(), // 使用当前广告主ID
            srcType: this.form.srcType,
            parentId: this.form.parentId,
            packageName: this.form.packageName,

          }
          if ( this.form.specialPage !==0){
            data.specialPage = this.form.specialPage
          }


          const response = await this.$axios.post('https://control.zjwec.cn/api/vivo/qdxcj', data);

          console.log(response.data.list[0]);
          self.resultList.push(
            response.data.list[0]
          );

          console.log(`ID ${uuid} 请求成功`);
        }

        console.log('所有请求已完成', self.resultList);
        this.exportToExcel()
        this.$message.success('所有操作已完成');
      } catch (error) {
        console.error('请求失败:', error);
        this.$message.error(`请求失败: ${error.message}`);

        this.exportToExcel()
        // 返回已完成的请求结果
        return results;
      }
    },
    // 生成时间戳文件名
    generateFileName() {
      const now = new Date()
      const pad = n => n.toString().padStart(2, '0')
      return `${now.getFullYear()}${pad(now.getMonth()+1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}.xlsx`
    },

    // 导出主方法
    exportToExcel() {
      const s = this
      try {
        // 1. 准备数据
        const headers = [
          '广告账号名称',
          '广告账号ID',

          '推广名称',
          'DP链接',
          'H5链接',
          '曝光监测',
          '点击监测',

          '建议出价'
        ]

        const data = s.resultList.map(item => [
          item.advertiser_name || '',
          item.advertiser_id || '',

          item.nickname || '',
          item.copyUrl || '',
          item.h5Url || '',
          item.impreUrl	 || '',
          item.callBackUrl || '',

          item.suggestBid	 || '',
        ])

        // 2. 创建工作簿
        const workbook = XLSX.utils.book_new()
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data])

        // 3. 设置列宽（可选）
        worksheet['!cols'] = [
          { wch: 15 }, // 广告账号ID
          { wch: 20 }, // 广告账号名称
          { wch: 20 }, // 推广名称
          { wch: 40 }, // DP链接
          { wch: 40 }, // H5链接
          { wch: 40 }, // H5链接
          { wch: 40 }, // H5链接
          { wch: 40 }  // 点击监测
        ]

        // 4. 添加工作表
        XLSX.utils.book_append_sheet(workbook, worksheet, '推广数据')

        // 5. 生成文件并保存
        const wbout = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        })

        const blob = new Blob([wbout], { type: 'application/octet-stream' })
        saveAs(blob, this.generateFileName())

        this.$message.success('导出成功')
      } catch (error) {
        console.error('导出失败:', error)
        this.$message.error('导出失败: ' + error.message)
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/qdxqdhcj.vue